import React from 'react';
import { Nav, NavDropdown, DropdownButton, Button } from 'react-bootstrap';
import { connect } from 'react-redux'
import { language } from '../language';
import HdHeader from '../Images/hdlogo.png';
import { Form } from 'react-bootstrap';

class Header2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      UserRole: this.props.Role,
      Username: this.props.username,
      Authority: {},
    }
  }

  async componentDidMount() {
    this.SetUsersAuthorities();
    // setstate to prevent users refresh the page.
    if (this.props.username === '' && this.props.token === '' && this.props.Role === ''){
      window.location.href = '/Login';
    }
  }

  SetUsersAuthorities() {
    const UserAuthorities = JSON.parse(localStorage.getItem('UserAuthority'))
    this.setState({
      Authority: UserAuthorities,
    })
  }

  async logout() {
    const r = (window.confirm('您确定要退出吗?'));
    if (r === true) {
      localStorage.removeItem('Username');
      localStorage.removeItem('Role');
      localStorage.removeItem('Token');
      localStorage.removeItem('UserAuthority');
      localStorage.removeItem('GameDisplay');
      localStorage.removeItem('LoginStatus');
      window.location.href = '/Login';
    } else {
      return null;
    }
  }

  render() {
    return (
      <div style={{ backgroundColor: '#444', position: 'fixed', height: '100vh', width: 150, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', padding: 10, textAlign: 'left', zIndex: 99}}>
        <Nav.Link href="/Home">
          <img src={HdHeader} alt="Logo" style={{ width: 100, height: 100 }} />
        </Nav.Link>
        <div style={{ color: 'white', marginBottom: 10, fontSize: 20, textAlign: 'center' }}>{this.props.username}</div>
        {this.state.UserRole === 'admin'  ? (
          <>
            {(this.state.Authority.isSub === 0 || (this.state.Authority && this.state.Authority.Bet) === 1) &&
              <DropdownButton variant="secondary" title={language[this.props.currentLanguage].Betting} id="basic-nav-dropdown" style={{ width: '100%', marginBottom: 10}}>
                {this.state.Authority.RebuyOrder === 1 && 
                  <>
                    <NavDropdown.Item href="/betting">{language[this.props.currentLanguage].Betting}({language[this.props.currentLanguage].FastVersion})</NavDropdown.Item>
                    {/* <NavDropdown.Item href="/BettingVersion2">{`${language[this.props.currentLanguage].BetSimple}`}</NavDropdown.Item> */}
                    <NavDropdown.Item href="/BoxVersion">{`${language[this.props.currentLanguage].Betting}(${language[this.props.currentLanguage].BoxVersion})`}</NavDropdown.Item>
                    {/* <NavDropdown.Item href="/BettingSgd">{language[this.props.currentLanguage].BettingSgd}</NavDropdown.Item>
                    <NavDropdown.Item href="/BettingThai">{language[this.props.currentLanguage].BettingThai}</NavDropdown.Item> */}
                    <NavDropdown.Item href="/BettingRed">{language[this.props.currentLanguage].Betting}({language[this.props.currentLanguage].RedNumber})</NavDropdown.Item>
                    <NavDropdown.Item href="/TextfileConvert">{language[this.props.currentLanguage].Document}</NavDropdown.Item>
                    <NavDropdown.Item href="/UploadCSV">{language[this.props.currentLanguage].UploadCSV}</NavDropdown.Item>
                    <NavDropdown.Item href="/101">{language[this.props.currentLanguage].onezeroone}</NavDropdown.Item>
                    <NavDropdown.Divider />
                  </>
                }
                {this.state.Authority.DisplayOrder === 1 && 
                  <>
                    {/* <NavDropdown.Item href="/ViewReceipt">{language[this.props.currentLanguage].BrowseTicket}</NavDropdown.Item> */}
                    <NavDropdown.Item href="/ViewReceiptV2">{language[this.props.currentLanguage].BrowseTicket}</NavDropdown.Item>
                    <NavDropdown.Item href="/LongTermReceipt">{language[this.props.currentLanguage].ShowLongTermOrder}</NavDropdown.Item>
                  </>}
                {this.state.Authority.DisplayOrder === 1 && 
                  <>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="/DisplayEditPage">{language[this.props.currentLanguage].EditedBetHistory}</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="/FindNumber">{language[this.props.currentLanguage].FindNumber}</NavDropdown.Item>
                  </>}
              </DropdownButton>
            }
            <DropdownButton variant="secondary" title={language[this.props.currentLanguage].Report} id="basic-nav-dropdown" style={{ width: '100%', marginBottom: 10}}>
              {this.state.Authority.Report === 1 && 
                <NavDropdown.Item href="/DownlineReport">{language[this.props.currentLanguage].ReportforHeader}</NavDropdown.Item>
              }
              {this.state.Authority.Report === 1 && 
                <>
                  <NavDropdown.Item href="/FirstReport">{language[this.props.currentLanguage].FirstReport}</NavDropdown.Item>
                  <NavDropdown.Item href="/SecondReport">{language[this.props.currentLanguage].SecondReport}</NavDropdown.Item>
                  <NavDropdown.Item href="/ZhonglaiCalculate">{language[this.props.currentLanguage].ZhonglaiCalculate}</NavDropdown.Item>
                  <NavDropdown.Divider />
                </>}
              {this.state.Authority.SalesReport === 1 && 
                <>
                  <NavDropdown.Item href="/Hit_Sales">{language[this.props.currentLanguage].AccountSales}</NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item href="/TodaySalesReport">{language[this.props.currentLanguage].TodaySalesReport}</NavDropdown.Item>
                  <NavDropdown.Item href="/GrandTotalNumberResult">{language[this.props.currentLanguage].SalesReport}</NavDropdown.Item>
                  <NavDropdown.Item href="/SimpleReport">{language[this.props.currentLanguage].SalesTypeReport}</NavDropdown.Item>
                  <NavDropdown.Item href="/GrandTotalNumberResultFight">{language[this.props.currentLanguage].eatSalesReport}</NavDropdown.Item>
                  <NavDropdown.Divider />
                </>}
              <NavDropdown.Item href="/ActionUserRecord">{language[this.props.currentLanguage].UserAction}</NavDropdown.Item>
              <NavDropdown.Item href="/SixDJackPotList">{language[this.props.currentLanguage].FreeJackpotList}</NavDropdown.Item>
            </DropdownButton>
            <DropdownButton variant="secondary" title={language[this.props.currentLanguage].Manage} id="basic-nav-dropdown" style={{ width: '100%', marginBottom: 10 }}>
              {this.state.Authority.EditBanNumber === 1 && 
                <>
                  <NavDropdown.Item href="/VIPuser">{language[this.props.currentLanguage].ExtraLimit}</NavDropdown.Item>
                  <NavDropdown.Item href="/RedNumber">{language[this.props.currentLanguage].RedNumber}</NavDropdown.Item>
                </>}
              {this.state.Authority.EditUser === 1 && 
                <NavDropdown.Item href="/HR">{language[this.props.currentLanguage].HR}</NavDropdown.Item>
              }
              {this.state.Authority.SystemSetting === 1 && 
                <NavDropdown.Item href="/UpdateLatestNews">{language[this.props.currentLanguage].NewsManage}</NavDropdown.Item>
              }
              {(this.state.Authority.SetOpenDate === 1 && this.state.Authority.SystemSetting === 1) && 
                <NavDropdown.Item href="/AddGame">{language[this.props.currentLanguage].Addgame}</NavDropdown.Item>
              }
              {this.state.Authority.SetGameResult === 1 && 
                <NavDropdown.Item href="/GameResult">{language[this.props.currentLanguage].GameResult}</NavDropdown.Item>
              }
              {this.state.Authority.SetOpenDate === 1 && 
                <NavDropdown.Item href="/GameSetting">{language[this.props.currentLanguage].GameSetting}</NavDropdown.Item>
              }
              <NavDropdown.Item href="/SendSMSGroup">{language[this.props.currentLanguage].SendSMSGroup}</NavDropdown.Item>
              <NavDropdown.Item href="/GenerateExcel">{language[this.props.currentLanguage].GenerateExcel}</NavDropdown.Item>
              {this.state.Authority.PinOrOutWord === 1 && 
                <>
                  <NavDropdown.Divider />
                  <NavDropdown.Item href="/Dading">{language[this.props.currentLanguage].Dading}</NavDropdown.Item>
                  <NavDropdown.Item href="/DadingConvert">{language[this.props.currentLanguage].DadingConvert}</NavDropdown.Item>
                  <NavDropdown.Item href="/DadingConvertCSV">{language[this.props.currentLanguage].DadingConvert}(CSV)</NavDropdown.Item>
                </>}
              {(this.state.Authority.isSub === 0 || (this.state.Authority && this.state.Authority.setting) === 1) &&
                <NavDropdown.Item href="/Setting">{language[this.props.currentLanguage].setting}</NavDropdown.Item>
              }
            </DropdownButton>
          </>
        ) : (this.props.Role === 'superAdmin') ? 
          (
            <>
              {(this.state.Authority.isSub === 0 || (this.state.Authority && this.state.Authority.Bet) === 1) &&
                <DropdownButton variant="secondary" title={language[this.props.currentLanguage].Betting} style={{ width: '100%', marginBottom: 10 }}>
                  {this.state.Authority.RebuyOrder === 1 && 
                    <>
                      <NavDropdown.Item href="/betting">{language[this.props.currentLanguage].Betting}({language[this.props.currentLanguage].FastVersion})</NavDropdown.Item>
                      {/* <NavDropdown.Item href="/BettingVersion2">{`${language[this.props.currentLanguage].BetSimple}`}</NavDropdown.Item> */}
                      <NavDropdown.Item href="/BoxVersion">{`${language[this.props.currentLanguage].Betting}(${language[this.props.currentLanguage].BoxVersion})`}</NavDropdown.Item>
                      {/* <NavDropdown.Item href="/BettingSgd">{language[this.props.currentLanguage].BettingSgd}</NavDropdown.Item>
                      <NavDropdown.Item href="/BettingThai">{language[this.props.currentLanguage].BettingThai}</NavDropdown.Item> */}
                      <NavDropdown.Item href="/BettingRed">{language[this.props.currentLanguage].Betting}({language[this.props.currentLanguage].RedNumber})</NavDropdown.Item>
                      <NavDropdown.Item href="/TextfileConvert">{language[this.props.currentLanguage].Document}</NavDropdown.Item>
                      <NavDropdown.Item href="/UploadCSV">{language[this.props.currentLanguage].UploadCSV}</NavDropdown.Item>
                      <NavDropdown.Item href="/101">{language[this.props.currentLanguage].onezeroone}</NavDropdown.Item>
                      <NavDropdown.Divider />
                    </>}
                  {this.state.Authority.DisplayOrder === 1 && 
                    <>
                      {/* <NavDropdown.Item href="/ViewReceipt">{language[this.props.currentLanguage].BrowseTicket}</NavDropdown.Item> */}
                      <NavDropdown.Item href="/ViewReceiptV2">{language[this.props.currentLanguage].BrowseTicket}</NavDropdown.Item>
                      <NavDropdown.Item href="/LongTermReceipt">{language[this.props.currentLanguage].ShowLongTermOrder}</NavDropdown.Item>
                    </>}
                  {this.state.Authority.DisplayOrder === 1 &&
                    <>
                      <NavDropdown.Divider />
                      <NavDropdown.Item href="/DisplayEditPage">{language[this.props.currentLanguage].EditedBetHistory}</NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item href="/FindNumber">{language[this.props.currentLanguage].FindNumber}</NavDropdown.Item>
                    </>}
                </DropdownButton>}
              <DropdownButton variant='secondary' title={language[this.props.currentLanguage].Report} style={{ width: '100%', marginBottom: 10 }}>
                {this.state.Authority.Report === 1 && 
                  <NavDropdown.Item href="/DownlineReport">{language[this.props.currentLanguage].ReportforHeader}</NavDropdown.Item>
                }
                {this.state.Authority.Report === 1 && 
                  <>
                    <NavDropdown.Item href="/FirstReport">{language[this.props.currentLanguage].FirstReport}</NavDropdown.Item>
                    <NavDropdown.Item href="/SecondReport">{language[this.props.currentLanguage].SecondReport}</NavDropdown.Item>
                    <NavDropdown.Item href="/ZhonglaiCalculate">{language[this.props.currentLanguage].ZhonglaiCalculate}</NavDropdown.Item>
                    <NavDropdown.Divider />
                  </>}
                {this.state.Authority.SalesReport === 1 &&
                  <>
                    <NavDropdown.Item href="/Hit_Sales">
                      {language[this.props.currentLanguage].AccountSales}
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="/TodaySalesReport">{language[this.props.currentLanguage].TodaySalesReport}</NavDropdown.Item>
                    <NavDropdown.Item href="/GrandTotalNumberResult">{language[this.props.currentLanguage].SalesReport}</NavDropdown.Item>
                    <NavDropdown.Item href="/SimpleReport">{language[this.props.currentLanguage].SalesTypeReport}</NavDropdown.Item> 
                    <NavDropdown.Item href="/GrandTotalNumberResultFight">{language[this.props.currentLanguage].eatSalesReport}</NavDropdown.Item>
                    <NavDropdown.Divider />
                  </>}
                <NavDropdown.Item href="/ActionUserRecord">{language[this.props.currentLanguage].UserAction }</NavDropdown.Item>
                <NavDropdown.Item href="/SixDJackPotList">{language[this.props.currentLanguage].FreeJackpotList}</NavDropdown.Item>
                <NavDropdown.Item href="/SMSReport">{language[this.props.currentLanguage].SMSReport}</NavDropdown.Item>
              </DropdownButton>
              <DropdownButton variant='secondary' title={language[this.props.currentLanguage].Manage} id="basic-nav-dropdown" style={{ width: '100%' }}>
                {this.state.Authority.EditBanNumber === 1 &&
                  <>
                    <NavDropdown.Item href="/VIPuser">{language[this.props.currentLanguage].ExtraLimit}</NavDropdown.Item> 
                    <NavDropdown.Item href="/RedNumber">{language[this.props.currentLanguage].RedNumber}</NavDropdown.Item>
                  </>
                }
                {this.state.Authority.EditUser === 1 && 
                  <NavDropdown.Item href="/HR">{language[this.props.currentLanguage].HR}</NavDropdown.Item>
                }
                {this.state.Authority.SystemSetting === 1 &&
                  <NavDropdown.Item href="/UpdateLatestNews">{language[this.props.currentLanguage].NewsManage}</NavDropdown.Item>  
                }
                {(this.state.Authority.SetOpenDate === 1 && this.state.Authority.SystemSetting === 1) && 
                  <NavDropdown.Item href="/AddGame">{language[this.props.currentLanguage].Addgame}</NavDropdown.Item>}
                {this.state.Authority.SetGameResult === 1 && 
                  <NavDropdown.Item href="/GameResult">{language[this.props.currentLanguage].GameResult}</NavDropdown.Item>
                }
                {this.state.Authority.SetOpenDate === 1 &&
                  <NavDropdown.Item href="/GameSetting">{language[this.props.currentLanguage].GameSetting}</NavDropdown.Item> 
                }
                <NavDropdown.Item href="/SendSMSGroup">{language[this.props.currentLanguage].SendSMSGroup}</NavDropdown.Item>
                <NavDropdown.Item href="/GenerateExcel">{language[this.props.currentLanguage].GenerateExcel}</NavDropdown.Item>
                <NavDropdown.Item href="/MultiNumberSearch">{language[this.props.currentLanguage].MultiNumberSearch}</NavDropdown.Item>
                {this.state.Authority.PinOrOutWord === 1 &&  
                  <>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="/Dading">{language[this.props.currentLanguage].Dading}</NavDropdown.Item>
                    <NavDropdown.Item href="/DadingConvert">{language[this.props.currentLanguage].DadingConvert}</NavDropdown.Item>
                    <NavDropdown.Item href="/DadingConvertCSV">{language[this.props.currentLanguage].DadingConvert}(CSV)</NavDropdown.Item>
                    <NavDropdown.Item href="/DadingConvertLing">{language[this.props.currentLanguage].DadingConvert}(PPL)</NavDropdown.Item>
                    <NavDropdown.Item href="/Caiding">拆钉</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="/filter">{language[this.props.currentLanguage].Dading}过滤</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="/SuperAdminManagePage">{language[this.props.currentLanguage].ManageAdminAuthority}</NavDropdown.Item>
                    <NavDropdown.Item href="/Setting">{language[this.props.currentLanguage].setting}</NavDropdown.Item>
                  </>}
              </DropdownButton>
            </>
          ) : (this.props.Role === 'agent') ? 
            (
              <>
                {(this.state.Authority.isSub === 0 || (this.state.Authority && (this.state.Authority.Bet || this.state.Authority.DisplayOrder)) === 1) &&
                  <DropdownButton variant='secondary' title={language[this.props.currentLanguage].Betting} style={{ width: '100%', marginBottom: 10 }}>
                    {this.state.Authority.RebuyOrder === 1 && 
                      <>
                        <NavDropdown.Item href="/betting">{language[this.props.currentLanguage].Betting}({language[this.props.currentLanguage].FastVersion})</NavDropdown.Item>
                        {/* <NavDropdown.Item href="/BettingVersion2">{`${language[this.props.currentLanguage].BetSimple}`}</NavDropdown.Item> */}
                        <NavDropdown.Item href="/BoxVersion">{`${language[this.props.currentLanguage].Betting}(${language[this.props.currentLanguage].BoxVersion})`}</NavDropdown.Item>
                        {/* <NavDropdown.Item href="/BettingSgd">{language[this.props.currentLanguage].BettingSgd}</NavDropdown.Item>
                        <NavDropdown.Item href="/BettingThai">{language[this.props.currentLanguage].BettingThai}</NavDropdown.Item> */}
                        {this.state.Authority.AbleRed === 1 && 
                          <NavDropdown.Item href="/BettingRed">{language[this.props.currentLanguage].Betting}({language[this.props.currentLanguage].RedNumber})</NavDropdown.Item>
                        }
                        <NavDropdown.Item href="/TextfileConvert">{language[this.props.currentLanguage].Document}</NavDropdown.Item>
                        <NavDropdown.Item href="/UploadCSV">{language[this.props.currentLanguage].UploadCSV}</NavDropdown.Item>
                        {(this.state.Authority.Able101Import === 1) &&
                          <NavDropdown.Item href="/101">{language[this.props.currentLanguage].onezeroone}</NavDropdown.Item>
                        }
                        <NavDropdown.Divider />
                      </>}
                    {this.state.Authority.DisplayOrder === 1 && 
                      <>
                        {/* <NavDropdown.Item href="/ViewReceipt">{language[this.props.currentLanguage].BrowseTicket}</NavDropdown.Item> */}
                        <NavDropdown.Item href="/ViewReceiptV2">{language[this.props.currentLanguage].BrowseTicket}</NavDropdown.Item>
                        <NavDropdown.Item href="/LongTermReceipt">{language[this.props.currentLanguage].ShowLongTermOrder}</NavDropdown.Item>
                      </>}
                    {this.state.Authority.DisplayOrder === 1 && 
                      <>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href="/DisplayEditPage">{language[this.props.currentLanguage].EditedBetHistory}</NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href="/FindNumber">{language[this.props.currentLanguage].FindNumber}</NavDropdown.Item>
                      </>}
                  </DropdownButton>}
                <DropdownButton variant='secondary' title={language[this.props.currentLanguage].Report} id="basic-nav-dropdown" style={{ width: '100%', marginBottom: 10 }}>
                  {this.state.Authority.Report === 1 && 
                    <NavDropdown.Item href="/DownlineReport">{language[this.props.currentLanguage].ReportforHeader}</NavDropdown.Item>
                  }
                  {this.state.Authority.Report === 1 &&  
                    <>
                      <NavDropdown.Item href="/FirstReport">{language[this.props.currentLanguage].FirstReport}</NavDropdown.Item>
                      <NavDropdown.Item href="/SecondReport">{language[this.props.currentLanguage].SecondReport}</NavDropdown.Item>
                      <NavDropdown.Divider />
                    </>}
                  {this.state.Authority.SalesReport === 1 &&
                    <>
                      <NavDropdown.Item href="/Hit_Sales">{language[this.props.currentLanguage].AccountSales}</NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item href="/TodaySalesReport">{language[this.props.currentLanguage].TodaySalesReport}</NavDropdown.Item>
                      <NavDropdown.Item href="/GrandTotalNumberResult">{language[this.props.currentLanguage].SalesReport}</NavDropdown.Item>
                      <NavDropdown.Item href="/SimpleReport">{language[this.props.currentLanguage].SalesTypeReport}</NavDropdown.Item>
                      <NavDropdown.Item href="/GrandTotalNumberResultFight">{language[this.props.currentLanguage].eatSalesReport}</NavDropdown.Item>
                    </>}
                </DropdownButton>
                <DropdownButton variant='secondary' title={language[this.props.currentLanguage].Manage} id="basic-nav-dropdown" style={{ width: '100%', marginBottom: 10}}>
                  {this.state.Authority.EditUser === 1 && 
                    <NavDropdown.Item href="/HR">{language[this.props.currentLanguage].HR}</NavDropdown.Item>
                  }
                  <NavDropdown.Divider />
                  {this.state.Authority.PinOrOutWord === 1 && this.state.Authority.AbleDading === 1 &&
                    <>
                      <NavDropdown.Divider />
                      <NavDropdown.Item href="/Dading">{language[this.props.currentLanguage].Dading}</NavDropdown.Item>
                    </>
                  }
                  {(this.state.Authority.isSub === 0 || (this.state.Authority && this.state.Authority.setting) === 1) &&
                    <NavDropdown.Item href="/Setting">{language[this.props.currentLanguage].setting}</NavDropdown.Item>
                  }
                </DropdownButton>
              </>
            ): (
              <>
                {(this.state.Authority.isSub === 0 || (this.state.Authority.isSub === 1 && (this.state.Authority.Bet || this.state.Authority.DisplayOrder))) && 
                  <DropdownButton variant='secondary' title={language[this.props.currentLanguage].Betting} id="basic-nav-dropdown" style={{ width: '100%', marginBottom: 10 }}>
                    {this.state.Authority.RebuyOrder === 1 && 
                      <>
                        <NavDropdown.Item href="/betting">{language[this.props.currentLanguage].Betting}({language[this.props.currentLanguage].FastVersion})</NavDropdown.Item>
                        {/* <NavDropdown.Item href="/BettingVersion2">{`${language[this.props.currentLanguage].BetSimple}`}</NavDropdown.Item> */}
                        <NavDropdown.Item href="/BoxVersion">{`${language[this.props.currentLanguage].Betting}(${language[this.props.currentLanguage].BoxVersion})`}</NavDropdown.Item>
                        {/* <NavDropdown.Item href="/BettingSgd">{language[this.props.currentLanguage].BettingSgd}</NavDropdown.Item>
                        <NavDropdown.Item href="/BettingThai">{language[this.props.currentLanguage].BettingThai}</NavDropdown.Item> */}
                        {this.state.Authority.AbleRed === 1 && 
                          <NavDropdown.Item href="/BettingRed">{language[this.props.currentLanguage].Betting}({language[this.props.currentLanguage].RedNumber})</NavDropdown.Item>
                        }
                        <NavDropdown.Item href="/TextfileConvert">{language[this.props.currentLanguage].Document}</NavDropdown.Item>
                        <NavDropdown.Item href="/UploadCSV">{language[this.props.currentLanguage].UploadCSV}</NavDropdown.Item>    
                        {(this.state.Authority.Able101Import === 1) && 
                          <NavDropdown.Item href="/101">{language[this.props.currentLanguage].onezeroone}</NavDropdown.Item>
                        }
                      </>}
                    {this.state.Authority.DisplayOrder === 1 && 
                      <>
                        <NavDropdown.Divider />
                        {/* <NavDropdown.Item href="/ViewReceipt">{language[this.props.currentLanguage].BrowseTicket}</NavDropdown.Item> */}
                        <NavDropdown.Item href="/ViewReceiptV2">{language[this.props.currentLanguage].BrowseTicket}</NavDropdown.Item>
                        <NavDropdown.Item href="/LongTermReceipt">{language[this.props.currentLanguage].ShowLongTermOrder}</NavDropdown.Item>
                      </>}
                    {this.state.Authority.DisplayOrder === 1 &&  
                      <>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href="/DisplayEditPage">{language[this.props.currentLanguage].EditedBetHistory}</NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href="/FindNumber">{language[this.props.currentLanguage].FindNumber}</NavDropdown.Item>
                      </>}
                  </DropdownButton>}
                <DropdownButton variant='secondary' title={language[this.props.currentLanguage].Report} id="basic-nav-dropdown" style={{ width: '100%', marginBottom: 10 }}>
                  {this.state.Authority.Report === 1 && 
                    <NavDropdown.Item href="/DownlineReport">{language[this.props.currentLanguage].ReportforHeader}</NavDropdown.Item>
                  }
                  {this.state.Authority.Report === 1 && 
                    <>
                      <NavDropdown.Item href="/FirstReport">{language[this.props.currentLanguage].FirstReport}</NavDropdown.Item>
                      <NavDropdown.Item href="/SecondReport">{language[this.props.currentLanguage].SecondReport}</NavDropdown.Item>
                      <NavDropdown.Divider />
                    </>
                  }
                  {this.state.Authority.SalesReport === 1 &&
                    <>
                      <NavDropdown.Item href="/Hit_Sales">{language[this.props.currentLanguage].AccountSales}</NavDropdown.Item> 
                      <NavDropdown.Divider />
                      <NavDropdown.Item href="/TodaySalesReport">{language[this.props.currentLanguage].TodaySalesReport}</NavDropdown.Item>
                      <NavDropdown.Item href="/GrandTotalNumberResult">{language[this.props.currentLanguage].SalesReport}</NavDropdown.Item>
                      <NavDropdown.Item href="/SimpleReport">{language[this.props.currentLanguage].SalesTypeReport}</NavDropdown.Item>
                      <NavDropdown.Item href="/GrandTotalNumberResultFight">{language[this.props.currentLanguage].eatSalesReport}</NavDropdown.Item>
                    </>}
                </DropdownButton>
                <DropdownButton variant='secondary' title={language[this.props.currentLanguage].Manage} id="basic-nav-dropdown" style={{ width: '100%'}}>
                  {this.state.Authority.EditUser === 1 && 
                    <NavDropdown.Item href="/HR">{language[this.props.currentLanguage].HR}</NavDropdown.Item>
                  }
                  {(this.state.Authority.AbleDading === 1) && <>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="/Dading">{language[this.props.currentLanguage].Dading}</NavDropdown.Item>
                  </>}
                  {(this.state.Authority.isSub === 0 || (this.state.Authority && this.state.Authority.setting) === 1) && <>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="/Setting">{language[this.props.currentLanguage].setting}</NavDropdown.Item>
                  </>}
                </DropdownButton>
              </>
            )}
        <div style={{ marginTop: 'auto', fontWeight: 'bold', width: 100, color: 'white' }}>{language[this.props.currentLanguage].ChangeLanguage}:  </div>
        <div style={{ width: '100%', alignItems: 'center'}}>
          <Form.Control  as="select" className="form-control button2" value={this.state.SelectedExample} onChange={(e) => this.props.setLanguage(e.target.value)} 
            style={{ textAlign: 'center', fontSize: 16}}>
            <option value="cn" selected={this.props.currentLanguage === 'cn'}>{language[this.props.currentLanguage].TranslateLanguageCN}</option>
            <option value="en" selected={this.props.currentLanguage === 'en'}>{language[this.props.currentLanguage].TranslateLanguageEN}</option>
            <option value="Malay" selected={this.props.currentLanguage === 'Malay'}>{language[this.props.currentLanguage].TranslateLanguageBM}</option>
          </Form.Control>
        </div>
        <Button variant="danger" style={{ marginTop: 10, width: '100%' }} onClick={() => this.logout()}>{language[this.props.currentLanguage].Logout} </Button>
      </div>
    );
  }
}

// export default Header2;

function mapStateToProps(state, ownProps) {
  return {
    username: state.username,
    token: state.token,
    Role: state.Role,
    currentLanguage: state.currentLanguage,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    setLanguage: (lg) => {
      dispatch({ type: 'SET_LANGUAGE', payload: lg });
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Header2);